<template>
    <div class="main">
  <div class="banner">
    <div class="banner-content">
      <navComponent :activeName="activeName"></navComponent>
      <productContentBanner></productContentBanner>
    </div>
  </div>
  <div class="type-area">
    <div class="type-area-center">
      <productRecommendation></productRecommendation>
    </div>
  </div>
  <footerComponent></footerComponent>
</div>
</template>
<script>
import productContentBanner from '/components/pc/headerComponent/productContentBanner.vue'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
import productRecommendation from '/components/pc/productContentComponent/ProductRecommendation/ProductRecommendation.vue'
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default {
  components:{
    productContentBanner,
    footerComponent,
    productRecommendation,
    navComponent
  },
    data() {
      return {
          activeName: 'second',
          // isNavScroll:false,
      };
    },
    mounted(){
      // window.addEventListener('scroll', () => {
      //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
      //   if (scrollTop > 88) {
      //     this.isNavScroll = true
      //   } else {
      //     this.isNavScroll = false
      //   }
      // });
    },
    methods: {
    }
  };
</script>

<style scoped lang="scss">
  @import '/style/pc/nav/nav.scss';
  @import '/style/phone/productContent/productContent.scss';
 .main {
    font-family: Inter;
    width: 100%;
    .type-area{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      .type-area-center{
      width: 75rem;
      }
    }
    .banner-content {
        width: 100%;
        height: 100%;
    }
    .banner1 {
        width: 100%;
    }
}

</style>